import { render, staticRenderFns } from "./safe-drawer-open-close.vue?vue&type=template&id=4b3df3a6&scoped=true"
import script from "./safe-drawer-open-close.vue?vue&type=script&lang=js"
export * from "./safe-drawer-open-close.vue?vue&type=script&lang=js"
import style0 from "./safe-drawer-open-close.vue?vue&type=style&index=0&id=4b3df3a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3df3a6",
  null
  
)

export default component.exports